enum Language {
  NORWEGIAN = 'no',
}

export default Language;
